import { render } from "./Diagnost.vue?vue&type=template&id=153b7cd0&scoped=true"
import script from "./Diagnost.vue?vue&type=script&lang=js"
export * from "./Diagnost.vue?vue&type=script&lang=js"

import "./Diagnost.vue?vue&type=style&index=0&id=153b7cd0&scoped=true&lang=css"

import exportComponent from "/builds/shapkin/crm-mentoring.exportedu.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153b7cd0"]])

export default __exports__